import { useAtomValue } from "jotai";
import { createPortal } from "react-dom";

import { DND_CANVAS_EDITOR_ID } from "../dnd/index.ts";
import { canvasSnapGuidesAtom } from "./canvasAtoms.ts";
import { SnapGuideLines } from "./SnapGuideLines.tsx";

/**
 * Single subscriber to `canvasSnapGuidesAtom` that portals the snap-guide
 * overlay into the editor container. Mount once per canvas (e.g. in
 * `LayoutContainerDndContext`) — keeping the subscription outside per-node
 * `ComposableWrapper`s avoids fanning a single atom update out to N renders,
 * which previously tripped React's "many updates inside startTransition"
 * warning whenever a guide appeared mid-drag.
 */
export const CanvasSnapGuidesLayer = () => {
  const snapGuides = useAtomValue(canvasSnapGuidesAtom);
  const editorContainer = document.getElementById(DND_CANVAS_EDITOR_ID);
  if (!editorContainer || !snapGuides || snapGuides.length === 0) return null;
  return createPortal(<SnapGuideLines guides={snapGuides} />, editorContainer);
};
